/**
 * product-recommendations.js — <product-recommendations>
 *
 * The `recommendations` Liquid object is only populated when the section is
 * requested through the Section Rendering API, so the element ships empty and
 * fetches its own markup. An empty response (no recommendations for this
 * product) leaves the element empty, which collapses the section — nothing to
 * hide by hand.
 */
if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._loaded || !this.dataset.url) return;
        this._loaded = true;

        fetch(this.dataset.url)
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((text) => {
            const fetched = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('product-recommendations');
            if (!fetched || !fetched.innerHTML.trim()) return;
            this.innerHTML = fetched.innerHTML;
            // The cards arrive after reveal.js has run, so they need to be
            // handed to its observer or they stay at opacity 0.
            document.dispatchEvent(new CustomEvent('on:reveal:scan'));
          })
          .catch(() => {});
      }
    }
  );
}
